import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { LoginLayout } from "../../../layouts/Login";
import { Button } from "../../../components/Button";
import { CreateForm } from "../components/CreateForm";

import { loginManagement } from "../../../hooks/api/LoginManagement";
import { Slide, toast, ToastContainer } from "react-toastify";

const ResetPassword = () => {
    const { t } = useTranslation("common");
    const formDefs = [
        {
            name: "newPassword",
            label: t("newPassword"),
            required: true,
            type: "password",
        },
        {
            name: "newPasswordConfirm",
            label: t("confirmedNewPassword"),
            required: true,
            type: "password",
        },
    ];
    const [resetPswInfo] = useState({
        newPassword: "",
        newPasswordConfirm: "",
    });
    const { useResetPasswordMutation } = loginManagement;
    const [resetPassword] = useResetPasswordMutation();
    const navigate = useNavigate();
    const { token } = useParams();

    const handleErrorMessage = (response) => {
        if(response?.error){
            const errorMessage = response?.error?.responseMessage || t("sentResetLinkSuccess");
            toast.error(errorMessage);
        }else{
            const info = response?.info?.responseMessage || t("sentResetLinkSuccess");
            toast.info(info);
        }
    };

    const validatePasswords = (newPassword, newPasswordConfirm) => {
        const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
        const numberRegex = /\d/;

        const passwordsMatch = newPassword === newPasswordConfirm;

        if (!passwordsMatch) {
            return false;
        }

        const newPasswordValid = specialCharRegex.test(newPassword) && numberRegex.test(newPassword);

        return newPasswordValid;
    };

    const handleSubmit = async (values) => {
        try {
            const isValid = validatePasswords(values?.newPassword, values?.newPasswordConfirm);

            if (!isValid) {
                toast.error(t("invalidPasswords"));
                return;
            }

            const response = await resetPassword({ body: values, token })?.unwrap();

            if (response?.error) {
                handleErrorMessage(response);
            } else {
                toast.info(t("passwordChangedSuccess"));
                navigate("/sign-up/login");
            }
        } catch (error) {
            handleErrorMessage(error?.data);
        }
    };

    return (
        <LoginLayout disableSplashScreen={true}>
             
            <CreateForm formDefs={formDefs} initialValues={resetPswInfo} onSubmit={(values) => handleSubmit(values)}>
                <Button type="submit">{t("save&Continue")}</Button>
            </CreateForm>
        </LoginLayout>
    );
};

export default ResetPassword;
